import classNames from 'classnames'
import React from 'react'

import { StatisticsType } from 'admin/types'
import Tooltip from 'components/ui/Tooltip'

const DashboardBarChart: React.FunctionComponent<DashboardBarChartProps> = props => {
  const { stats: { items, count, max }, axisComponent, tooltipComponent, labelComponent, className } = props
  if (count > 0) {
    const axisLabels = getRoundedAxisLabels(max)
    return <div className={classNames('BarChart', className)}>
      <div className="BarChart__x-axis">
        {axisLabels.map((axisLabel, axisIndex) => (
          axisComponent
            ? React.createElement(axisComponent, {key: `xaxis_${  axisIndex}`, style: {bottom: `${axisLabel / max * 100}%`}}, axisLabel)
            : <span key={`xaxis_${  axisIndex}`} style={{top: `${axisLabel / max * 100}%`}}>{axisLabel}</span>
        ))}
      </div>
      {items && items.map(item => (
        <Tooltip key={`bar_${  item.id}`} text={tooltipComponent ? React.createElement(tooltipComponent, {item}) : <span>{`${item.label  } ${  item.value}`}</span>}>
          <div
            className="BarChart__bar"
            style={{
              opacity: (0.5 * item.value / max) + 0.5,
              height: `${item.value / max * 100}%`,
            }}
          >
            {item.label && labelComponent
              ? React.createElement(labelComponent, null, item.label)
              : <span>{item.label}</span>
            }
          </div>
        </Tooltip>
      ))}
    </div>
  } 
    return null
  
}

type DashboardBarChartProps = {
  stats: StatisticsType | null,
  axisComponent?: React.ClassType<any, any, any>,
  tooltipComponent?: React.ClassType<any, any, any>,
  labelComponent?: React.ClassType<any, any, any>,
  className?: string,
}

/**
 * Get a list of axis labels at rounded powers of ten increments at points below max value
 * For 4321 the labels are 4000, 3000, 2000 and 1000
 */
function getRoundedAxisLabels(max: number, count: number = 10): number[] {
  // Rounding factor is the closest lower power of ten, eg. 1000 for 4321
  const rounding = 10**Math.floor(Math.log10(max))
  const labels = []
  for (let n = 0 ; n < count ; n++) {
    const label = Math.floor((max - n * rounding) / rounding) * rounding
    if (label <= 0) break
    labels.push(label)
  }
  return labels
}

export default DashboardBarChart